import React from 'react';
import {Button} from 'primereact/button';

const BaseButtonText = (props) => {
  return (<>
    <Button {...props} className={`${props.custom ? props.custom : ''} ${props.extra ? props.extra : ''}`}/>
  </>);
};

export default BaseButtonText;